import { ActionButton, Icon } from '@fluentui/react';
import ChatButton from '../../../common/views/ChatButton';
import { Utils } from '../../../common/views/Utils';
import { OrderModel } from '../../models/OrderModel';
import { OrderUtils } from '../shared/OrderUtils';

export type OrderItemProps = {
    order: OrderModel;
    onDetail: (order: OrderModel) => void;
    onDelete: (order: OrderModel) => void;
}

export default function RequestedOrderItemView({ order, onDetail, onDelete }: OrderItemProps) {
    const isMobile = window.innerWidth <= 500;
    const width3 = Utils.getColumnWidth(3);
    const width4 = Utils.getColumnWidth(4);
    const width6 = Utils.getColumnWidth(6);
    const width9 = Utils.getColumnWidth(9);

    function productInfo() {
        return <div className="left">
            {order.product && <div>
                <div className="limit-lines two-lines">
                    {order.product.link ?? "Not Available"}
                </div>

                {!Utils.isNullOrEmpty(order.note) && <div className="pt-5 limit-lines two-lines gray">
                    Note: {order.note}
                </div>}

                <div className="pt-5">{Utils.formatShortDate(order.orderDate)}</div>
            </div>}
        </div>;
    }

    const onProductDetail = () => {
        if (order.product && order.product.link) {
            window.open(order.product.link, "_blank");
        } else {
            alert("Product link not available.");
        }
    }

    const actionRow = () => {
        return <div className="ms-Grid-row default-toolbar">
            <div className={width4 + " left"}>
                <ChatButton />
            </div>

            <div className={width4 + " center"}>
                <ActionButton
                    iconProps={{ iconName: "Delete" }}
                    onClick={() => onDelete(order)}
                >Delete</ActionButton>
            </div>

            <div className={width4 + " right"}>
                <ActionButton
                    iconProps={{ iconName: "Product" }}
                    onClick={onProductDetail}
                >Product</ActionButton>
            </div>
        </div>;
    }

    return <div className="ph-15">
        <div className="ms-Grid pt-10 default-border">
            <div className="ms-Grid-row ph-5" style={{ minHeight: isMobile ? 0 : 110 }}>
                <div className={width9}>
                    {productInfo()}
                </div>

                <div className={width3 + " right"}>
                    <div>{OrderUtils.getStatusText(order.status)}</div>

                    <div className="right mt--20 pt-25" style={{ position: "relative" }}>
                        <span className="count">{order.qty}</span>
                    </div>
                </div>
            </div>
            <div className="pt-10">
                {actionRow()}
            </div>
        </div>
    </div>;
}